__turbopack_context__.v({
  "captcha": "JZ8l9G_captcha",
  "wrapper": "JZ8l9G_wrapper",
});
